export default "__VITE_ASSET__DoqzV79W__"